(function ListFilterToggle($, Adzuki)
{
	"use strict";

	var FilterToggle = function filterToggle()
	{
		this.formControl           = $('.toggle-form-control');
		this.formContainer         = $('.toggleable-form');
		this.toggleFormMessage     = $('.toggle-form-message ');
		this.minimizeClass         = 'minus';
		this.maximizeClass         = 'plus';
		// this.hideContainerClass    = 'hidden';
		this.cookieName            = this.formControl.data('cookie-name') || null;
		this.cookieValue           = Cookies.get(this.cookieName) || null;

		this.init = function init() {
			if (this.formControl.length) {
				if (!this.cookieName) {
					console.log('data-cookie-name must be defined for the .toggle-form-control element');
				}
				this.setToggleIconByCookie();
			}
		};
		this.init();
	};

	FilterToggle.prototype.setToggleIconByCookie = function setToggleIconByCookie() {
		if ( (parseInt(this.cookieValue) === 1) || (this.formContainer.hasClass('in')) ) {
			this.formControl.addClass(this.minimizeClass);
		} else {
			this.formControl.addClass(this.maximizeClass);
		}
	};

	FilterToggle.prototype.toggleSearchForm = function toggleSearchForm() {
		var expanded = 0;

		if (this.formControl.hasClass(this.minimizeClass)) {
			this.formControl.removeClass(this.minimizeClass);
			this.formControl.addClass(this.maximizeClass);

			if (this.toggleFormMessage.length) {
				this.toggleFormMessage.removeClass('hidden');
			}
		} else {
			this.formControl.removeClass(this.maximizeClass);
			this.formControl.addClass(this.minimizeClass);

			if (this.toggleFormMessage.length) {
				this.toggleFormMessage.addClass('hidden');
			}

			expanded = 1;
		}

		// this.formContainer.toggleClass(this.hideContainerClass);
		this.formContainer.collapse('toggle');

		Cookies.set(this.cookieName, expanded, {
				path: '/'
		});
	};

	$(document).ready(function documentReady()
	{
		var filter;

		if ($('.toggleable-form').length) {
			filter = new FilterToggle();

			$('.toggle-form-control').click(function toggleSearch() {
				filter.toggleSearchForm();
			});
		}
	});

}(jQuery, window.Adzuki || {}));
